import { formatCurrency } from "@/lib/format";

// A customer/vendor has an "outstanding balance" if either the flattened
// balance or any of the per-currency outstanding rows is non-zero (>0.5¢).
export function hasOutstandingBalance(party) {
  if (Array.isArray(party?.balance_by_currency) &&
      party.balance_by_currency.some((b) => Math.abs(Number(b.outstanding || 0)) > 0.005)) {
    return true;
  }
  return Math.abs(Number(party?.balance || 0)) > 0.005;
}

export function formatMoney(n, ccy = "USD") { return formatCurrency(Number(n || 0), ccy); }

// Stable client-side ID for dynamic form rows (invoice/bill line items).
// Ensures React reconciliation doesn't stale-mount inputs when rows are
// deleted from the middle of the list.
export let _rid = 0;
export function newRid() { _rid += 1; return `r${_rid}`; }
export function withRid(line) { return { _rid: newRid(), ...line }; }

export const STATUS_STYLES = {
  draft: "bg-[var(--hover)] text-[var(--muted-text)]",
  sent: "bg-[#EEF3F3] text-[#2F4F4F]",
  paid: "bg-[#E5F1E9] text-[#2F6B4A]",
  overdue: "bg-[#FCE7E9] text-[#B4283A]",
  void: "bg-[#E5E5E5] text-[#5C5C5C]",
};

